export default __webpack_public_path__ + "static/media/8.662a155d.jpg";